import React, { useEffect, useRef } from 'react';
import { createStreetMap } from './streetMap.jsx';
import './areaMap.scss';

// نقشه‌های نمایشِ محدوده (فقط نمایش؛ جابه‌جایی و زوم غیرفعال)

const PREVIEW_BG = '#f4f1ea';
const WORLD_RING = [
  [-180, -85],
  [180, -85],
  [180, 85],
  [-180, 85],
  [-180, -85],
];

const ringOfGeo = (g) => (g && g.geometry ? g.geometry : g)?.coordinates?.[0] || null;

function freezeMap(map) {
  ['dragPan', 'scrollZoom', 'boxZoom', 'dragRotate', 'keyboard', 'doubleClickZoom', 'touchZoomRotate'].forEach((h) => map[h]?.disable());
}

function boundsOf(rings) {
  const pts = rings.flat();
  const lngs = pts.map((p) => p[0]);
  const lats = pts.map((p) => p[1]);
  return [
    [Math.min(...lngs), Math.min(...lats)],
    [Math.max(...lngs), Math.max(...lats)],
  ];
}

// یک محدوده، «کراپ‌شده»: فقط خودِ محدوده دیده می‌شود و بیرونش با رنگِ زمینه پوشیده است
export function AreaPreview({ geojson }) {
  const ref = useRef(null);
  useEffect(() => {
    const ring = ringOfGeo(geojson);
    if (!ref.current || !ring) return undefined;
    const map = createStreetMap(ref.current, { nav: false, zoom: 12 });
    freezeMap(map);
    const mask = { type: 'Feature', properties: {}, geometry: { type: 'Polygon', coordinates: [WORLD_RING, ring] } };
    map.on('load', () => {
      map.addSource('area', { type: 'geojson', data: { type: 'Feature', properties: {}, geometry: { type: 'Polygon', coordinates: [ring] } } });
      map.addSource('area-mask', { type: 'geojson', data: mask });
      map.addLayer({ id: 'area-mask-fill', type: 'fill', source: 'area-mask', paint: { 'fill-color': PREVIEW_BG, 'fill-opacity': 1 } });
      map.addLayer({ id: 'area-fill', type: 'fill', source: 'area', paint: { 'fill-color': '#0a66c2', 'fill-opacity': 0.12 } });
      map.addLayer({ id: 'area-line', type: 'line', source: 'area', paint: { 'line-color': '#0a66c2', 'line-width': 2.5 } });
      map.fitBounds(boundsOf([ring]), { padding: 28, maxZoom: 16, duration: 0 });
    });
    return () => map.remove();
  }, [geojson]);
  return <div ref={ref} className="area-map area-map--crop" />;
}

// چند محدوده روی یک نقشه (همه‌ی محدوده‌های کاری مشاور). onClick اختیاری است
export function AreasOverview({ areas, onClick, height = 150 }) {
  const ref = useRef(null);
  const rings = (areas || []).map(ringOfGeo).filter(Boolean);
  const key = JSON.stringify(rings);
  useEffect(() => {
    if (!ref.current || !rings.length) return undefined;
    const map = createStreetMap(ref.current, { nav: false, zoom: 10 });
    freezeMap(map);
    map.on('load', () => {
      map.addSource('areas', {
        type: 'geojson',
        data: { type: 'FeatureCollection', features: rings.map((r) => ({ type: 'Feature', properties: {}, geometry: { type: 'Polygon', coordinates: [r] } })) },
      });
      map.addLayer({ id: 'areas-fill', type: 'fill', source: 'areas', paint: { 'fill-color': '#0a66c2', 'fill-opacity': 0.18 } });
      map.addLayer({ id: 'areas-line', type: 'line', source: 'areas', paint: { 'line-color': '#0a66c2', 'line-width': 2 } });
      map.fitBounds(boundsOf(rings), { padding: 20, maxZoom: 15, duration: 0 });
    });
    return () => map.remove();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key]);
  return (
    <div className="area-map-wrap" style={{ height }} onClick={onClick} role={onClick ? 'button' : undefined}>
      <div ref={ref} className="area-map area-map--overview" />
      {!rings.length && <span className="area-map-wrap__empty">هنوز محدوده‌ای مشخص نشده</span>}
    </div>
  );
}
